var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 51,
    viewBox: "0 0 71 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4163 44.3188C39.6546 44.3188 49.5757 34.3977 49.5757 22.1594C49.5757 9.9211 39.6546 0 27.4163 0C15.178 0 5.25684 9.9211 5.25684 22.1594C5.25684 34.3977 15.178 44.3188 27.4163 44.3188Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4847 26.2987C29.7707 26.2987 31.6239 24.4455 31.6239 22.1595C31.6239 19.8735 29.7707 18.0203 27.4847 18.0203C25.1987 18.0203 23.3455 19.8735 23.3455 22.1595C23.3455 24.4455 25.1987 26.2987 27.4847 26.2987ZM20.0524 38.2358V50.7448H13.9466V39.1277C13.9466 36.6122 12.3687 35.423 10.402 35.423C8.1609 35.423 6.60589 36.7265 6.60589 39.6079V50.7219H0.5V22.228H6.60589V32.2901C7.70357 30.7807 9.73885 29.7974 12.4373 29.7974C16.5536 29.8203 20.0524 32.7474 20.0524 38.2358ZM30.3431 30.3921H24.2373V50.7678H30.3431V30.3921ZM54.3778 38.2358V50.7447H48.272V39.1276C48.272 36.6121 46.694 35.423 44.7274 35.423C42.4863 35.423 40.9312 36.7265 40.9312 39.6079V50.7219H34.8254V30.3462H40.9312V32.2671C42.0289 30.7578 44.0642 29.7745 46.7626 29.7745C50.8789 29.8202 54.3778 32.7474 54.3778 38.2358ZM66.3151 43.4497V36.2462H70.4771V30.3919H66.2923V24.6977L60.1864 26.5272V30.3919H56.9163V36.2462H60.1864V43.4497C60.1864 49.1668 62.519 51.568 70.5 50.7447V45.2106C67.8244 45.3707 66.3151 45.2106 66.3151 43.4497Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4055 22.1535) scale(22.1556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#00AEEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.3424,
    y1: 58.1289,
    x2: 39.9094,
    y2: 22.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5087e5854d2e5cb3ef5e8661069de2a2.svg";
export { ForwardRef as ReactComponent };